// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"ccee45fe","336":"c0886255"}[chunkId] + ".chunk.css";
};